<template>
    <div>
        <textarea
            ref="input"
            id="stupid-input"
            v-model="inputValue"
            @focus="$emit('focus')"
            @focusout="$emit('focusout')"
            :style="styleObject"
            :placeholder="placeholder"
            class="resize-none block w-full outline-none placeholder-primary-40"
            :class="[ 'text-' + fontSize, ...inputClass.split(' '), disabled ? 'bg-white' : '']"
            :disabled="disabled"
            :tabindex="tabIndex"
        ></textarea>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        fontSize: {
            validator: value => !isNaN(value),
            default: 14,
            required: false,
        },
        inputClass: {
            type: String,
            default: '',
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        disabled: Boolean,
        tabIndex: null,
    },
    data: function () {
        return {
            height: this.fontSize * 1.5,
        }
    },
    computed: {
        inputValue: {
            get () {
                return this.value;
            },
            set (val) {
                this.$emit('input', val);
            }
        },
        styleObject () {
            return {
                height: this.height + 'px',
            }
        }
    },
    methods: {
        setHeight () {
            let el = this.$refs.input;
            this.height = this.fontSize * 1.5;
            this.$nextTick(() => {
                this.height = el.scrollHeight;
            })
        },
        focus () {
            this.$refs.input.focus();
        }
    },
    watch: {
        value (val) {
            this.setHeight();
        }
    },
    mounted () {
        this.setHeight();
    }
}
</script>
